import { ProductType } from 'shared/products/domain/productType';
import {
  isBulkStorage,
  isCoilStorage,
  isLogYard,
  isPackageIntake,
  isPackageOutput,
  isPackageStorage,
  type StorageAreaType,
} from 'shared/storageAreas/domain/storageAreaType';

export function storageAreaMatchesProductType(
  productType: ProductType,
  storageAreaType: StorageAreaType,
) {
  switch (productType) {
    case ProductType.Log:
      return isLogYard(storageAreaType);
    case ProductType.Coil:
      return isCoilStorage(storageAreaType);
    case ProductType.Bulk:
      return isBulkStorage(storageAreaType);
    case ProductType.Dimension:
      return (
        isPackageStorage(storageAreaType) ||
        isPackageOutput(storageAreaType) ||
        isPackageIntake(storageAreaType)
      );
    default:
      return false;
  }
}
